import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTButtonComponent } from './components/lt-button/lt-button.component';
import { LTButtonGoBackComponent } from './components/lt-button-go-back/lt-button-go-back.component';
import { LTButtonToggleComponent } from './components/lt-button-toggle/lt-button-toggle.component';
import { LTSplitButtonComponent } from './components/lt-split-button/lt-split-button.component';
import { LTCurrentStatusToggleComponent } from './components/lt-current-status-toggle/lt-current-status-toggle';
import { LTSwitchComponent } from './components/lt-switch/lt-switch.component';
@NgModule({
  imports: [
    CommonModule,
    LTButtonComponent,
    LTButtonGoBackComponent,
    LTButtonToggleComponent,
    LTCurrentStatusToggleComponent,
    LTSplitButtonComponent,
    LTSwitchComponent,
  ],
  exports: [
    LTButtonComponent,
    LTButtonGoBackComponent,
    LTButtonToggleComponent,
    LTCurrentStatusToggleComponent,
    LTSplitButtonComponent,
    LTSwitchComponent,
  ],
})
export class LTButtonModule { }